import { GitCompareArrows, Trash2, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useCompare } from "../../contexts/CompareContext";

export const CompareDock = () => {
  const { items, toggle, clear } = useCompare();
  if (!items.length) return null;
  return (
    <aside className="fixed bottom-4 left-1/2 z-50 w-[calc(100%-2rem)] max-w-4xl -translate-x-1/2 border border-slate-600 bg-slate-950/95 p-3 shadow-2xl backdrop-blur-xl" data-testid="compare-dock">
      <div className="flex items-center gap-3">
        <div className="hidden h-11 w-11 place-items-center bg-orange-500 text-white sm:grid"><GitCompareArrows className="h-5 w-5" /></div>
        <div className="min-w-0 flex-1">
          <div className="text-xs font-bold uppercase text-orange-400">Compare machines</div>
          <div className="mt-1 flex gap-2 overflow-hidden">
            {items.map((item) => <button key={item.id} onClick={() => toggle(item)} className="inline-flex max-w-44 items-center gap-1 truncate text-xs text-slate-300" data-testid={`compare-dock-remove-${item.id}`}>{item.model}<X className="h-3 w-3" /></button>)}
          </div>
        </div>
        <button onClick={clear} className="grid h-10 w-10 place-items-center border border-slate-700 text-slate-300 hover:text-white" aria-label="Clear comparison" data-testid="compare-clear-button"><Trash2 className="h-4 w-4" /></button>
        <Link to="/compare" className="inline-flex h-10 items-center bg-orange-500 px-4 text-sm font-bold uppercase text-white" data-testid="compare-open-button">Compare {items.length}</Link>
      </div>
    </aside>
  );
};